import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import './Options.scss';
// import { redirect } from '../../../redux/actions/redirectActions';
//
function Options() {
	const gameUrl = useSelector((state) => state.clock.roomURL);
	const [copied, setCopied] = React.useState(false);

	const dispatch = useDispatch();
	const leave = () => {
		dispatch({ type: 'LEAVE_GAME' });
		// dispatch(redirect(''));
	};
	return (
		<div>
			<div className="cmd-container">
				<CopyToClipboard text={gameUrl} onCopy={() => setCopied(true)}>
					<button className="cmd-btn cmd-resign " title="Copy link" type="button">
						<i className="material-icons">file_copy</i>
					</button>
				</CopyToClipboard>
				<button
					className="cmd-btn cmd-exit"
					title="Quit"
					type="button"
					onClick={leave}
				>
					<i className="material-icons">close</i>
				</button>

				<div className="link-value">
					<input
						type="text"
						disabled
						className={`${copied ? 'is-valid' : ''} form-control`}
						value={gameUrl}
					/>
				</div>
			</div>
		</div>
	);
}

export default Options;
